const PlayIcon: React.FC = () => {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9.36 28.7498C8.05 28.7498 7 27.6898 7 26.3898V21.6598C7 20.3498 8.06 19.2998 9.36 19.2998"
                stroke="white"
                stroke-miterlimit="10"
            />
            <path
                d="M30.6396 19.2998C31.9496 19.2998 32.9996 20.3598 32.9996 21.6598V26.3898C32.9996 27.6998 31.9396 28.7498 30.6396 28.7498"
                stroke="white"
                stroke-miterlimit="10"
            />
            <path
                d="M20.0002 12.5502C21.9608 12.5502 23.5502 10.9608 23.5502 9.0002C23.5502 7.03958 21.9608 5.4502 20.0002 5.4502C18.0396 5.4502 16.4502 7.03958 16.4502 9.0002C16.4502 10.9608 18.0396 12.5502 20.0002 12.5502Z"
                stroke="white"
                stroke-miterlimit="10"
            />
            <path
                d="M30.5 19.3301C30.59 19.7001 30.64 20.0801 30.64 20.4801V27.5701C30.64 27.9001 30.61 28.2101 30.54 28.5201"
                stroke="white"
                stroke-miterlimit="10"
            />
            <path
                d="M30.5404 28.5202C30.1004 30.6702 28.1904 32.2902 25.9104 32.2902H14.0904C11.4804 32.2902 9.36035 30.1702 9.36035 27.5602V20.4702C9.36035 17.8602 11.4804 15.7402 14.0904 15.7402H25.9104C28.1304 15.7402 29.9804 17.2602 30.5004 19.3202"
                stroke="white"
                stroke-miterlimit="10"
            />
            <path
                d="M15.2702 25.2005C16.5735 25.2005 17.6302 24.1439 17.6302 22.8405C17.6302 21.5371 16.5735 20.4805 15.2702 20.4805C13.9668 20.4805 12.9102 21.5371 12.9102 22.8405C12.9102 24.1439 13.9668 25.2005 15.2702 25.2005Z"
                stroke="white"
                stroke-miterlimit="10"
            />
            <path
                d="M24.7301 25.2005C26.0335 25.2005 27.0901 24.1439 27.0901 22.8405C27.0901 21.5371 26.0335 20.4805 24.7301 20.4805C23.4267 20.4805 22.3701 21.5371 22.3701 22.8405C22.3701 24.1439 23.4267 25.2005 24.7301 25.2005Z"
                stroke="white"
                stroke-miterlimit="10"
            />
            <path d="M20 12.5498V15.7498" stroke="white" stroke-miterlimit="10" />
        </svg>
    )
}

export default PlayIcon
